
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_1ag6b_93",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_1ag6b_1",
  "root": "awsui_root_mx3cw_1ag6b_119",
  "hidden": "awsui_hidden_mx3cw_1ag6b_157",
  "with-dismiss": "awsui_with-dismiss_mx3cw_1ag6b_207",
  "with-action": "awsui_with-action_mx3cw_1ag6b_207",
  "breakpoint-default": "awsui_breakpoint-default_mx3cw_1ag6b_213",
  "header": "awsui_header_mx3cw_1ag6b_220",
  "action": "awsui_action_mx3cw_1ag6b_224",
  "action-slot": "awsui_action-slot_mx3cw_1ag6b_229",
  "action-button": "awsui_action-button_mx3cw_1ag6b_230",
  "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_1ag6b_234",
  "text": "awsui_text_mx3cw_1ag6b_263",
  "icon": "awsui_icon_mx3cw_1ag6b_270",
  "message": "awsui_message_mx3cw_1ag6b_273",
  "icon-size-medium": "awsui_icon-size-medium_mx3cw_1ag6b_281",
  "icon-size-big": "awsui_icon-size-big_mx3cw_1ag6b_284",
  "icon-size-normal": "awsui_icon-size-normal_mx3cw_1ag6b_287",
  "content": "awsui_content_mx3cw_1ag6b_291",
  "dismiss": "awsui_dismiss_mx3cw_1ag6b_295",
  "dismiss-button": "awsui_dismiss-button_mx3cw_1ag6b_300",
  "type-error": "awsui_type-error_mx3cw_1ag6b_304",
  "type-warning": "awsui_type-warning_mx3cw_1ag6b_312",
  "type-success": "awsui_type-success_mx3cw_1ag6b_320",
  "type-info": "awsui_type-info_mx3cw_1ag6b_328"
};
  